import React from "react";
import { Row, Col, Table } from "react-bootstrap";
import ImagePreview from "../../utilities/ImagePreview";
import { StepNavigation } from "../../utilities/StepperComponents";

const SummaryStep = ({ data, passportURL, signatureURL, prevStep, handleSubmit, isSubmitting }) => {
	const renderSection = (title, fields) => (
		<div className="summary-section mb-4">
			<h5 className="summary-section-title">{title}</h5>
			<Table responsive borderless className="summary-table">
				<tbody>
					{fields.map(([label, value]) => (
						<tr key={label}>
							<td className="field-label">{label}</td>
							<td className="field-value">{value || <span className="text-muted">Not provided</span>}</td>
						</tr>
					))}
				</tbody>
			</Table>
		</div>
	);

	return (
		<div className="modern-form-container summary-container">
			<div className="summary-header mb-4">
				<h4>Review Your Information</h4>
				<p className="text-muted">Please confirm that all details are correct before submitting your registration.</p>
			</div>

			{renderSection("Payment Details", [
				["Teller Name", data.tellerName],
				["Teller Ref Number", data.tellerRefNum],
				["Bank Name", data.bankName],
				["Date of Payment", data.paymentDate],
				["Amount Paid", "₦" + data.amountPaid],
			])}

			{renderSection("Employment Details", [
				["Organisation", data.organisationName],
				["Rank", data.rank],
				["Grade Level", data.gradeLevel],
				["Step", data.step],
				["Retirement Date", data.retirementDate],
				["Campus", data.campusName],
				["Salary Structure", data.salaryStructure],
				["Faculty", data.faculty],
				["Department", data.department],
				["Staff Number", data.staffNum],
			])}

			{renderSection("Personal Details", [
				["Title", data.title],
				["Gender", data.gender],
				["Full Name", data.fullName],
				["Date of Birth", data.birthDate],
				["Email", data.email],
				["Phone", data.phone],
				["Home Address", data.homeAddress],
			])}

			<div className="summary-section mb-4">
				<h5 className="summary-section-title">Documents</h5>
				<Row>
					<Col md={6} className="text-center mb-3">
						<label className="d-block mb-2 font-weight-bold">Passport Photograph</label>
						{passportURL ? (
							<div className="summary-image-wrapper">
								<img src={passportURL} alt="Passport" className="summary-preview-img" />
							</div>
						) : (
							<span className="text-danger">Missing Passport</span>
						)}
					</Col>
					<Col md={6} className="text-center mb-3">
						<label className="d-block mb-2 font-weight-bold">Digital Signature</label>
						{signatureURL ? (
							<div className="summary-image-wrapper">
								<img src={signatureURL} alt="Signature" className="summary-preview-img" />
							</div>
						) : (
							<span className="text-danger">Missing Signature</span>
						)}
					</Col>
				</Row>
			</div>

			<StepNavigation
				currentStep={4}
				totalSteps={4}
				onPrev={prevStep}
				onPreview={handleSubmit}
				isSubmitting={isSubmitting}
			/>

			<style dangerouslySetInnerHTML={{ __html: `
				.summary-container {
					padding: 20px;
					background: #fff;
					border-radius: 8px;
				}
				.summary-section-title {
					color: #0b7e45;
					border-bottom: 2px solid #f0fdf4;
					padding-bottom: 8px;
					margin-bottom: 15px;
					font-weight: 700;
					text-transform: uppercase;
					font-size: 0.9rem;
					letter-spacing: 0.5px;
				}
				.summary-table td {
					padding: 8px 0;
					font-size: 0.95rem;
				}
				.field-label {
					font-weight: 600;
					color: #4a5568;
					width: 40%;
				}
				.field-value {
					color: #2d3748;
				}
				.summary-image-wrapper {
					border: 2px dashed #e2e8f0;
					padding: 10px;
					border-radius: 8px;
					display: inline-block;
				}
				.summary-preview-img {
					max-width: 150px;
					max-height: 150px;
					border-radius: 4px;
					object-fit: cover;
				}
			`}} />
		</div>
	);
};

export default SummaryStep;
